export default __webpack_public_path__ + "static/media/Interventoría-en-topografía.f775d639.png";